export const criteriaFields = {
	search: '',
	pageIndex: 0,
	pageSize: 5,
	sortFields: []
};

export const defaultCollectionCriteria = {
	// anything that needs to see when records are deleted
	roles: { limit: false },
	cases: { limit: false },
	submissions: { limit: false },
	envelopes: {
		sortFields: [{ fld: ['Created'], dir: 'desc' }],
		limit: false
	},
	templates: {
		sortFields: [{ fld: ['name'], dir: 'asc' }],
		limit: false
	},
	extensions: {
		sortFields: [{ fld: ['uri'], dir: 'asc' }, { fld: ['type'], dir: 'asc' }, { fld: ['name'], dir: 'asc' }]
	},
	jobs: {
		sortFields: [{ fld: ['startTime'], dir: 'desc' }],
		limit: false,
	},
	urls: {
		sortFields: [{ fld: ['route'], dir: 'asc' }],
		limit: false,
	},
	assets: {
		sortFields: [{ fld: ['path'], dir: 'asc' }],
		limit: false,
	},
	caseMetricAdjustments: {
		sortFields: [{ fld: ['dateLabel'], dir: 'desc' }],
		limit: false,
	},
	telephonySessions: {
		sortFields: [{ fld: ['startTime'], dir: 'desc' }],
		limit: 20
	},
	calls: {
		sortFields: [{ fld: ['startTimeUTC'], dir: 'desc' }],
		limit: 20
	},
	previousCalls: {
		sortFields: [{ fld: ['startTime'], dir: 'desc' }],
		limit: 20
	}
};
